<!-- eslint-disable no-undef -->
<template>  
    <div>
        <el-collapse-transition>
        <div v-show="showUploadDokumen">
            
            <el-row :gutter="20" style="margin-bottom: 20px;">
                <el-col :span="1"><el-button type="plain" size="mini" icon="el-icon-arrow-left" plain @click="showSenarai">kembali</el-button></el-col>
            </el-row>

            <el-steps :active="active" align-center>
                <el-step title="Muat Naik" description="dokumen Excel">
                    <template slot="icon">
                        <i class="el-icon-upload" @click="resetupload" style="cursor: pointer;"></i>
                    </template>
                </el-step>
                <el-step title="Status" icon="el-icon-info" description="Berjaya / gagal butiran disimpan"></el-step>
            </el-steps>
            
            
            <div v-if="active === 0" style="padding: 50px 302px;">                
                <el-upload
                    action=""
                    accept=".xlsx,.xls,.csv"
                    drag
                    ref="uploader"
                    :on-change="parseXLS"
                    :limit="1"
                    :auto-upload="false"
                    :file-list="fileList"
                    style="width: 400px;">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">Sila pilih fail <em>excel</em></div>
                </el-upload>
            </div>
        </div>
        </el-collapse-transition>
    </div>
</template>


<script>
import axios from 'axios'
import moment from 'moment'
import * as XLSX from 'xlsx';
export default {
    name: 'Upload',
    data() {
        return {
            showUploadDokumen: true,
            fileList: [],
            docs: {
                sheet: '',
                data: [],
                dbdata: []
            },
            workbook: {},
            active: 0,
            paging: {
                currentPage: 1,
                pageSize: 100
            },
            hasError: false,
            errors: [],
            lookup: {},
            uploadType: '',
            saved: false
        }
    },
    methods: {
        showSenarai() {
            this.$parent.currentview = 'senarai'
        },
        resetupload() {
            this.active = 0;
            this.docs.data = []    
            this.docs.dbdata = []    
            this.workbook = {}
        },

        parseXLS(file) {                
            this.saved = false;        
            const loading = this.$loading({
                lock: true,
                text: 'membaca fail..',
                spinner: 'el-icon-loading',
            });
            setTimeout(() => {
                var reader = new FileReader();
                this.active++;
                var _this = this;
                reader.onload = function(e) {
                    var data = new Uint8Array(e.target.result);
                    _this.workbook = XLSX.read(data, {type: 'array'});
                    _this.workbook.SheetNames = _this.workbook.SheetNames.filter( f => f != 'LOOKUP' ) 
                    loading.close(); 
                    _this.setData();                   
                };
                reader.readAsArrayBuffer(file.raw);

                
            }, 1000);
        },
        setData() {
            if(this.active === 1) {
                this.active++;
            }
            else {
                this.docs.data = [];
                this.docs.dbdata = [];
            }
            
            var lastRow = parseInt(Object.keys(this.workbook.Sheets[this.workbook.SheetNames[0]]).slice(-2,-1)[0].replace(/[^0-9]/g,''));

            moment.locale('en');

            try {
                let row = this.workbook.Sheets[this.workbook.SheetNames[0]];   
                             console.log(row);
                // let lookup = this.lookup;
                let _this = this;

                const loading = this.$loading({
                    lock: true,
                    text: 'Sila tunggu! Sebanyak ' + (lastRow - 1) + ' rekod sedang diproses untuk dimuat ke paparan skrin.',
                    spinner: 'el-icon-loading',
                });
                setTimeout(() => {                
                    for (let index = 2; index <= lastRow; index++) {
                        let tkhJoined, tkhActivity;    

                        if(row['C' + index]) {
                            tkhJoined = row['C' + index].v.replace(',','')
                            tkhJoined = moment(tkhJoined, "YYYY/MM/DD hh:mm:ssA");
                            tkhJoined = tkhJoined.format("YYYY-MM-DD HH:mm:ss")
                        }
                        else {
                            tkhJoined = '';
                        }

                        if(row['D' + index]) {
                            tkhActivity = row['D' + index].v.replace(',','')
                            tkhActivity = moment(tkhActivity, "YYYY/MM/DD hh:mm:ssA");
                            tkhActivity = tkhActivity.format("YYYY-MM-DD HH:mm:ss")
                        }
                        else {
                            tkhActivity = '';
                        }      
                        
                        let tel = !row['M' + index] ? '' : row['M' + index].v.toString();
                        tel = tel.substring(0,2) == '60' ? tel : tel.substring(0,2) == '01' ? '6'+tel : '60'+tel;

                        let itel = !row['P' + index] ? '' : row['P' + index].v.toString();
                        itel = itel.substring(0,2) == '60' ? itel : itel.substring(0,2) == '01' ? '6'+itel : '60'+itel;

                        if(row['A' + index] || row['C' + index]) {
                            this.docs.data.push({
                                nama:         row['A' + index] ? row['A' + index].v : '',
                                email:        row['B' + index] ? row['B' + index].v : '',
                                joined:       tkhJoined,
                                lastactivity: tkhActivity,
                                addedvia:     row['E' + index] ? row['E' + index].v : '',
                                optinmethod:  row['F' + index] ? row['F' + index].v : '',
                                ipaddress:    row['G' + index] ? row['G' + index].v : '',
                                country:      row['H' + index] ? row['H' + index].v : '',
                                countrycode:  row['I' + index] ? row['I' + index].v : '',
                                signedupfrom: row['J' + index] ? row['J' + index].v : '',
                                status:       row['K' + index] ? row['K' + index].v : '',
                                gdpr:         row['L' + index] ? row['L' + index].v : '',
                                tel:          tel.length < 5 ? '' : tel,
                                introducer:   row['N' + index] ? row['N' + index].v : '',
                                pgcode:       row['O' + index] ? row['O' + index].v : '',
                                itel:         itel.length < 5 ? '' : itel,
                                iemail:       row['Q' + index] ? row['Q' + index].v : '',
                                webid:        row['R' + index] ? row['R' + index].v : '',
                            });
                        }              
                    }
                    
                    axios.post('/upload',  {
                        data: _this.docs.data
                    })
                    .then( () => {                        
                        this.$message({
                            message: 'Butiran data dari excel telah berjaya dimuat naik',
                            type: 'success',
                            onClose: function(){  
                                _this.docs.data = []
                                _this.docs.dbdata = []
                                _this.saved = true;
                                _this.active = 0;
                                _this.workbook = {};         
                            }
                        });
                        loading.close();
                    }).catch(() => {});

                }, 1000);
                
            } catch (error) {
                console.error(error);
                
                this.docs.data = [];
                this.docs.dbdata = [];
                this.$message({                                
                    message: 'Maaf, butiran pada sheet tersebut tidak lengkap atau tidak mengikut standard yang ditetapkan.',
                    type: 'error',
                    onClose: function(){           
                    }
                });
            }
        }
    },
}


</script>